import {
  B_20,
  BANNER_DEFAULTS,
  hideB20Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

import defaultLogoImage from "@stadium/shared/src/assets/images/plasmic-static-slices/header-logo.svg";
import stadiumLogo from "@stadium/shared/src/assets/images/stadium-logo.svg";

export const B20_PLASMIC_PROPS = {
  b20NewsletterTitle: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_20].newsletterTitle,
    description: "Newsletter title (B20 only)",
    hidden: hideB20Props,
  },
  b20NewsletterPlaceholder: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_20].newsletterPlaceholder,
    description: "Newsletter input placeholder (B20 only)",
    hidden: hideB20Props,
  },
  b20NewsletterButtonAriaLabel: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_20].newsletterButtonAriaLabel,
    description: "Newsletter button aria label (B20 only)",
    hidden: hideB20Props,
  },
  b20LogoImage: {
    type: "imageUrl",
    defaultValue: defaultLogoImage,
    description: "Logo image (B20 only)",
    hidden: hideB20Props,
  },
  b20LogoImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_20].logoImageAlt,
    description: "Logo image alt text (B20 only)",
    hidden: hideB20Props,
  },
  b20PrimaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_20].primaryButtonText,
    description: "Primary CTA button text (B20 only)",
    hidden: hideB20Props,
  },
  b20PrimaryButtonUrl: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_20].primaryButtonUrl,
    description: "Primary CTA button URL (B20 only)",
    hidden: hideB20Props,
  },
  b20PoweredByImage: {
    type: "imageUrl",
    defaultValue: stadiumLogo,
    description: "Powered by image (B20 only)",
    hidden: hideB20Props,
  },
  b20PoweredByImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_20].poweredByImageAlt,
    description: "Powered by image alt text (B20 only)",
    hidden: hideB20Props,
  },
  b20BackgroundVector: {
    type: "imageUrl",
    description: "Background vector image (B20 only)",
    hidden: hideB20Props,
  },
};
